import { Tooltip, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import DefaultProfileImage from '~/images/doctor.png';
import { Box } from '../Box';

interface IProfessionalPictureProps {
  imageUrl: string;
  name: string;
  size?: number;
}

export const ProfessionalPicture = ({ imageUrl, name, size = 48 }: IProfessionalPictureProps) => {
  return (
    <Tooltip
      content={
        <Typography as="span" bold color={colors.shades[0]}>
          {name}
        </Typography>
      }
      placement="bottom"
    >
      <Box
        alignItems="center"
        backgroundColor="#DFEBED"
        borderRadius="100%"
        height={size}
        justifyContent="center"
        justifySelf="flex-end"
        width={size}
      >
        {imageUrl ? (
          <img
            src={imageUrl}
            height="100%"
            width="100%"
            style={{
              borderRadius: 100,
              objectFit: 'cover',
            }}
          />
        ) : (
          <img src={DefaultProfileImage} height={36} width={36} />
        )}
      </Box>
    </Tooltip>
  );
};
